import {obtenerFechaEstandarCheckIn} from "../Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../Funciones/obtenerFechaEstandarCheckOut";
import {FECHACHECKIN, FECHACHECKOUT} from "../Constantes";


export const adaptadorReservaHabitacionVista = ({reserva, habitacion, fechaEscogida}) => {


    let obj = {
        ...habitacion,
        estado: reserva.estado,
        nombres: reserva.nombres,
        apellidos: reserva.apellidos,
        celular: reserva.celular,
        correo: reserva.correo,
        ciudad: reserva.ciudad,
        ciudadProcendencia: reserva.ciudadProcendencia,
        cc: reserva.cc,
        tipoCc: reserva.tipoCc,
       // tarifa: reserva.tarifa,
        ccPrincipal: reserva.ccPrincipal,
        id: reserva.id,
        FECHACHECKIN: reserva[FECHACHECKIN],
        FECHACHECKOUT: reserva[FECHACHECKOUT],
        idHabitacion: habitacion.id,
        motivo: reserva.motivo,
        notas: reserva.notas,
        numHuespedes: reserva.numHuespedes,
        valor: reserva.valor,
        valorAbonado: reserva.valorAbonado ? reserva.valorAbonado : 0,
        abonos: reserva.abonos ? reserva.abonos : []

    }

    let fechaSalidaHoy = obtenerFechaEstandarCheckOut(new Date().getTime())
    if (obj[FECHACHECKOUT] === fechaSalidaHoy) {
        obj.estado = 'Salida'
    }

   // console.log('reserva', obj)

    return obj


}